<div class="position-relative progessbar-outer">
  <ngb-progressbar [value]="100" *ngIf="isLoading"></ngb-progressbar>
</div>
<div class="row border-bottom">
  <div class="col my-auto">
    <h2>
      <span *ngIf="user && user.role==role.Admin">Automations </span> 
      <span *ngIf="user && user.role!=role.Admin">Configuration </span> 
      <small role="button" style="font-size: 20px;" (click)="onRefresh()">
        <i class="fa fa-refresh text-primary"></i>
      </small>
    </h2>
  </div>
  <div class="col col-md-auto my-auto p-0" *ngIf="user && user.role==role.Admin">
    <input type="text" placeholder="Company Name" [(ngModel)]="companyName" (keyup.enter)="onSearchByCompanyName()"
      class="form-control form-control-sm float-right mr-2" style="width: 165px;" />
  </div>
  
  <div class="col col-md-auto my-auto" *ngIf="user && user.role==role.Admin">
    <!-- <a routerLink="/connection/New/{{uId}}/name"  class="btn btn-primary btn-sm float-right ml-2">Add Automation</a> -->
    <a class="btn btn-primary btn-sm float-right" routerLink="/user/add-user">Add User</a>
  </div>
</div>
<div class="table-container">
  <table class="table  table-striped">
    <thead class="fixed">
      <tr>
        <th style="width: 60%">Automation Name</th>
        <th style="width: 15%">Status</th>
        <th style="width: 25%" *ngIf="user.role==role.Admin">Company Name</th>
        <th style="width: 15%"></th>
      </tr>
    </thead>
    <tbody>

      <tr *ngFor="let Connection of Connections">

        <td>{{Connection.automationName}}</td>
        <td>{{Connection.status}}</td>
        <td *ngIf="user.role==role.Admin">{{Connection.companyName}}</td>
        <td style="white-space: nowrap;display:inline-flex">
          <!-- <a class="enable-link mx-2" routerLink="/connection/summary/{{Connection.aUID}}" data-toggle="tooltip" data-placement="bottom" title="View">
    <i class="fa fa-eye" aria-hidden="true"></i>
  </a> -->

          <div *ngIf="Connection.status == 'Pending' ; then ifblockP else ifblockA "></div>

          <ng-template #ifblockP>
            <a class="enable-link mx-1" *ngIf="user.role==role.Admin" data-toggle="tooltip" data-placement="bottom" title="Edit"
               routerLink="/connection/New/{{Connection.userUID}}/name/edit/{{Connection.aUID}}">
              <i class="fa fa-edit"></i>
            </a>

            <a class="enable-link mx-1 badge badge-primary" href="javascript:void()" (click)="onPublish(Connection)">
              Install
            </a>

            <a class="enable-link mx-1" href="javascript:void()" *ngIf="user.role==role.Admin" (click)="deleteConnector(Connection.aUID)" data-toggle="tooltip" data-placement="bottom" title="Delete">
              <i class="fa fa-trash text-danger"></i>
            </a>
          </ng-template>

          <ng-template #ifblockA>
            <!--<a class="disabled-link" routerLink="/connection/New/{{uId}}/name/edit/{{Connection.aUID}}"><i class="fa fa-edit"></i></a>
    <a class="disabled-link" href="javascript:void()" (click)="deleteConnector(Connection.aUID)" style="margin-left:10px"><i class="fa fa-trash"></i></a>-->
            <a class="enable-link mx-1 badge badge-primary" *ngIf="Connection.status == 'Active' && Connection.connectorName =='Slack'" href="javascript:void()" (click)="onUnpublish(Connection)">
              Uninstall
            </a>
          </ng-template>

          <!--<div *ngIf="Connection.status == 'Active' ; then ifblock1 else ifblock2"></div>-->
          <div *ngIf="Connection.status != 'Pending' ; then ifblock1 else ifblock2"></div>

          <ng-template #ifblock1>
            <div *ngIf="Connection.connectorName !='Slack'">
              <!--ADD CONDITION FOR HIDE ACTIVE/INACTIVE BUTTON FOR SLACK ONLY-->
              <div *ngIf="Connection.status == 'Active' ; then ifblockActive else ifblockInActive"></div>
              <ng-template #ifblockActive>
                <a class="enable-link mx-2" href="javascript:void()" data-toggle="tooltip" data-placement="bottom" title="Active" (click)="ActicveInActive(Connection.aUID)">
                  <i class="fas fa-toggle-on"></i>
                </a>

              </ng-template>
              <ng-template #ifblockInActive>
                <span *ngIf="Connection.status == 'InActive'">
                  <a class="enable-link mx-2" href="javascript:void()" data-toggle="tooltip" data-placement="bottom" title="InActive" (click)="ActicveInActive(Connection.aUID)">
                    <i class="fas fa-toggle-off"></i>
                  </a>
                </span>
              </ng-template>
            </div>
          </ng-template>
          <!--Not Pending template-->
          <ng-template #ifblock2>
            <!--<a class="disabled-link" href="javascript:void()" (click)="ActicveInActive(Connection.aUID)" style="margin-left:10px">
      <i class="fas fa-toggle-off"></i>
    </a>-->
          </ng-template>

          <div *ngIf="Connection.status != 'Pending' ; then ReInstall else NotReInstall"></div>
          
          <ng-template #ReInstall>
            <div *ngIf="Connection.status == 'Active' ; then ifblockActive1 else ifblockInActive1"></div>
            <ng-template #ifblockActive1>
              <span *ngIf="Connection.cid == teamsConnectorId">

                <a class="enable-link mx-2" href="javascript:void()" title="Reinstall" (click)="Reinstall(Connection.aUID)">
                  <i class="fas fa-download"></i>
                </a>
              </span>
            </ng-template>
            <ng-template #ifblockInActive1>


            </ng-template>

          </ng-template>
          <!--Not Pending template-->
          <ng-template #NotReInstall>

          </ng-template>
        </td>

      </tr>

      <tr *ngIf="!Connections">
        <td colspan="4" class="text-center">
          <span class="spinner-border spinner-border-lg align-center"></span>
        </td>
      </tr>
      <tr *ngIf="Connections && Connections.length==0 && !isLoading">
        <td colspan="4" class="text-center">
          No Record !!
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div *ngIf="user.role==role.Admin">
  <ngb-pagination [collectionSize]="paginagination.collectionSize" [(page)]="paginagination.pageSize"
    [maxSize]="paginagination.maxSize" [boundaryLinks]="true" (pageChange)="onChangePage($event)">
  </ngb-pagination>
</div>
